import { HttpContextToken } from '@angular/common/http';

/**
 * Opt-in flag for a single HTTP request: when set to true, error interceptors
 * pass the raw HttpErrorResponse downstream instead of mapping it to a string.
 * Use on endpoints that need access to status/url/body in catchError.
 */
export const PASS_RAW_ERROR = new HttpContextToken<boolean>(() => false);